import type { DispatchPreview } from '../dispatch.api';
import { canOfferAbort } from '../policies/abort-visibility.policy';
import { canOfferHandover } from '../policies/handover-visibility.policy';
import { AbortPanel } from './AbortPanel';
import { DispatchedSummary } from './DispatchedSummary';
import { HandoverPanel } from './HandoverPanel';

interface DispatchedPanelsProps {
  preview: DispatchPreview & { dispatch: NonNullable<DispatchPreview['dispatch']> };
  canDispatch: boolean;
  onChanged: () => void;
}

/** The overview once the trip has gone: what was given, who has driven it, and the actions that change the trip itself (hand over, abort). */
export function DispatchedPanels({ preview, canDispatch, onChanged }: DispatchedPanelsProps) {
  return (
    <>
      <DispatchedSummary record={preview.dispatch} />
      <HandoverPanel
        tripId={preview.trip.id}
        currentDriverName={preview.crew.driver?.label ?? null}
        canHandOver={canOfferHandover(preview.trip.status, canDispatch)}
        onHandedOver={onChanged}
      />
      <AbortPanel tripId={preview.trip.id} canAbort={canOfferAbort(preview.trip.status, canDispatch)} onAborted={onChanged} />
    </>
  );
}
